import type { ReactNode } from 'react'

export interface SelectionSummaryLabels {
  /**
   * Optional custom renderer for the count. Defaults to the built-in two-tone
   * `selected / total` rendering. Receives the already-resolved displayed
   * number (which equals `total` when nothing is selected).
   */
  summary?: (selected: number, total: number) => ReactNode
  clear: string
}

export const DEFAULT_SELECTION_SUMMARY_LABELS: SelectionSummaryLabels = {
  clear: 'Clear',
}
